<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>For Jessie</i></span></p>
<p class="ded1"><span><i>and Ettore Rella</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?0ecc1716